function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "60px",
    width: "60px",
    id: "Layer_1",
    viewBox: "0 0 511.974 511.974",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M236.269,7.437C234.863,2.999,230.753,0,226.098,0H112.854c-3.594,0-6.953,1.796-8.921,4.796  s-2.297,6.797-0.875,10.094l33.107,76.605c0.156,0.375,0.344,0.75,0.547,1.094c5.531,9.624,11.546,26.639,8.437,33.576  c-6.484,14.452-10.171,27.561-10.312,27.764c-0.719,1.031-11.765,9.234-12.093,10.453l-5.641,21.077  c-0.609,2.312-0.438,4.749,0.5,6.937l27.467,64.544c0.016,0.062,0.047,0.109,0.062,0.172l41.889,94.072  c0.906,2.031,2.422,3.719,4.328,4.844l30.217,17.859c1.641,0.969,3.516,1.483,5.422,1.483h16.562c5.078,0,9.437-3.577,10.453-8.546  c1.984-9.828,19.437-96.37,20.701-111.822c3.406-41.936-2.03-96.386-16.187-161.835C248.034,44.685,236.738,8.937,236.269,7.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC87C0"
    },
    d: "M142.634,132.024c13.108,12.859,54.325,52.654,80.23,70.95l50.998-12.906  c-0.047-0.5-0.078-1-0.125-1.516c-28.045-15.468-108.76-77.417-139.336-101.119l1.765,4.062c0.156,0.375,0.344,0.75,0.547,1.094  c5.531,9.624,11.546,26.639,8.437,33.576C144.259,128.15,143.415,130.119,142.634,132.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D770AD"
    },
    d: "M273.564,186.787l-101.011,32.171l12.406,34.639l90.651-31.607  C275.407,210.895,274.719,199.162,273.564,186.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC87C0"
    },
    d: "M225.145,337.045c-11.89-13.265-18.999-42.263-25.264-67.84  c-5.266-21.468-10.234-41.748-18.062-55.513c-17.187-30.232-40.31-53.185-41.279-54.153l-5.703-5.609l-6.984,3.891  c-2.109,1.172-51.56,29.217-53.185,72.027c-1.016,26.53,15.608,46.528,30.264,64.169c8.703,10.468,16.921,20.373,20.187,29.998  c5.14,15.187,7.296,56.935,9.031,90.479c1.453,28.218,2.703,52.591,5.421,64.528c5.187,22.764,28.483,32.951,49.263,32.951  c5.593,0,13.39-0.766,18.843-4.344c3.484-2.312,6.546-5.719,14.296-28.795c3.859-11.484,8.609-27.062,14.109-46.264  c9.312-32.561,17.702-64.855,17.796-65.184l2.047-7.891l-7.078-4.047C244.722,353.091,232.426,345.185,225.145,337.045z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D770AD"
    },
    d: "M136.524,454.633c0.812,10.312,1.766,18.749,3.047,24.39c5.187,22.764,28.483,32.951,49.263,32.951   c5.593,0,13.39-0.766,18.843-4.344c3.484-2.312,6.546-5.719,14.296-28.795c1.703-5.047,3.578-10.906,5.609-17.5   C211.02,468.538,179.788,475.241,136.524,454.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D770AD"
    },
    d: "M251.596,63.169c-18.53,2.25-77.746,8.656-125.384,5.312l9.953,23.015   c0.156,0.375,0.344,0.75,0.547,1.094c0.938,1.624,1.891,3.468,2.797,5.437c51.544,3.859,100.854-3.906,118.509-7.155   C255.862,81.027,253.69,71.731,251.596,63.169z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M397.931,7.437C396.525,2.999,392.416,0,387.76,0H274.517c-3.594,0-6.953,1.796-8.922,4.796  s-2.297,6.797-0.875,10.094l33.107,76.605c0.156,0.375,0.344,0.75,0.547,1.094c5.531,9.624,11.547,26.639,8.438,33.576  c-6.484,14.452-10.172,27.561-10.312,27.764c-0.719,1.031-11.766,9.234-12.094,10.453l-5.64,21.077  c-0.609,2.312-0.438,4.749,0.484,6.937l27.483,64.544c0.016,0.062,0.047,0.109,0.062,0.172l41.889,94.072  c0.905,2.031,2.405,3.719,4.327,4.844l30.218,17.859c1.641,0.969,3.515,1.483,5.421,1.483h16.562c5.078,0,9.438-3.577,10.453-8.546  c1.984-9.828,19.436-96.37,20.701-111.822c3.406-41.936-2.031-96.386-16.186-161.835C409.697,44.685,398.4,8.937,397.931,7.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC87C0"
    },
    d: "M304.297,132.024c13.108,12.859,54.324,52.654,80.23,70.95l50.996-12.906  c-0.047-0.5-0.094-1-0.125-1.516c-28.045-15.468-108.76-77.417-139.336-101.119l1.766,4.062c0.156,0.375,0.344,0.75,0.547,1.094  c5.531,9.624,11.547,26.639,8.438,33.576C305.922,128.15,305.078,130.119,304.297,132.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D770AD"
    },
    d: "M435.226,186.787l-101.01,32.171l12.406,34.639l90.65-31.607  C437.07,210.895,436.383,199.162,435.226,186.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC87C0"
    },
    d: "M386.807,337.045c-11.89-13.265-18.999-42.263-25.265-67.84  c-5.265-21.468-10.233-41.748-18.061-55.513c-17.188-30.232-40.311-53.185-41.295-54.153l-5.688-5.609l-6.984,3.891  c-2.109,1.172-51.559,29.217-53.184,72.027c-1.016,26.53,15.608,46.528,30.264,64.169c8.702,10.468,16.921,20.373,20.186,29.998  c5.141,15.187,7.297,56.935,9.031,90.479c1.453,28.218,2.703,52.591,5.422,64.528c5.188,22.764,28.482,32.951,49.263,32.951  c5.594,0,13.39-0.766,18.843-4.344c3.484-2.312,6.547-5.719,14.297-28.795c3.858-11.484,8.608-27.062,14.107-46.264  c9.312-32.561,17.703-64.855,17.781-65.184l2.062-7.891l-7.078-4.047C406.384,353.091,394.089,345.185,386.807,337.045z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D770AD"
    },
    d: "M298.187,454.633c0.812,10.312,1.766,18.749,3.047,24.39c5.188,22.764,28.482,32.951,49.263,32.951   c5.594,0,13.39-0.766,18.843-4.344c3.484-2.312,6.547-5.719,14.297-28.795c1.703-5.047,3.577-10.906,5.608-17.5   C372.683,468.538,341.451,475.241,298.187,454.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D770AD"
    },
    d: "M413.259,63.169c-18.53,2.25-77.746,8.656-125.385,5.312l9.953,23.015   c0.156,0.375,0.344,0.75,0.547,1.094c0.938,1.624,1.891,3.468,2.797,5.437c51.544,3.859,100.854-3.906,118.51-7.155   C417.525,81.027,415.353,71.731,413.259,63.169z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallet);
export default __webpack_public_path__ + "static/media/ballet.9b7993d0c80a1bc7ef6c4303165b701d.svg";
export { ForwardRef as ReactComponent };